import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-approval-letter',
  templateUrl: './approval-letter.component.html',
  styleUrls: ['./approval-letter.component.css']
})
export class ApprovalLetterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
